module.exports = __webpack_public_path__ + "static/media/integration.6157e960.svg";